// import Header from "../header"



// const ApplyNow = () => {

// return (
//     <div>
//         <Header />
//         <h3>hi</h3>
//     </div>
// )

// }


// export default ApplyNow

import React, { useState } from 'react';
import './index.css'; // Import the CSS file
import Header from '../header';
import TaskBar from '../taskbar';
import CopyRight from '../copyright';
import { collection, addDoc } from 'firebase/firestore'; // Import Firestore functions
import { db } from '../firebase';

const ApplyNow = () => {
  const [formData, setFormData] = useState({
    countriesOfInterest: [],
    studyYear: '',
    highestQualification: '',
    graduationYear: '',
    studyBranch: '',
    fullName: '',
    mobileNumber: '',
    emailAddress: '',
    cityOfBirth: '',
    referralSource: '',
    consulted: 'NO'
  });

  const countries = [
    'USA',
    'UK',
    'Australia',
    'Canada',
    'New Zealand',
    'France',
    'Germany',
  ];

  const studyYears = ['2025', '2026', '2027', 'Later'];
  const qualifications = ['High School', 'Bachelor\'s Degree', 'Master\'s Degree', 'Doctorate', 'Other'];
  const referralSources = ['Friend/Family', 'Social Media', 'Website Search', 'Educational Fair', 'Other'];

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prevData) => {
      if (type === 'checkbox') {
        return {
          ...prevData,
          [name]: checked
            ? [...prevData[name], value]
            : prevData[name].filter((country) => country !== value),
        };
      } else {
        return {
          ...prevData,
          [name]: value,
        };
      }
    });
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   // In a real application, you would send this data to your server
  //   console.log('Form Data Submitted:', formData);
  //   alert('Form submitted! (Check console for data)');
  //   // Optionally reset the form:
  //   // setFormData({
  //   //   countriesOfInterest: [],
  //   //   studyYear: '',
  //   //   highestQualification: '',
  //   //   graduationYear: '',
  //   //   studyBranch: '',
  //   //   fullName: '',
  //   //   mobileNumber: '',
  //   //   emailAddress: '',
  //   //   cityOfBirth: '',
  //   //   referralSource: '',
  //   // });
  // };

  const handleSubmit = async (event) => { // Make handleSubmit an async function
    event.preventDefault();
    //setIsSubmitting(true); // Disable the button
    //setSubmissionError(null); // Clear any previous error
    try {
      // 1. Get a reference to the "formsdata" collection
      const formsCollectionRef = collection(db, 'formsdata');

      // 2. Add the form data as a new document to the collection
      const docRef = await addDoc(formsCollectionRef, formData);

      console.log('Document written with ID: ', docRef.id);
      alert('Form submitted successfully!'); // Basic success message.  Consider a better UI notification.

      // Optionally reset the form:
      setFormData({
        countriesOfInterest: [],
        studyYear: '',
        highestQualification: '',
        graduationYear: '',
        studyBranch: '',
        fullName: '',
        mobileNumber: '',
        emailAddress: '',
        cityOfBirth: '',
        referralSource: '',
      });
    } catch (error) {
      console.error('Error adding document: ', error);
      //setSubmissionError(error.message || 'Failed to submit form. Please try again.'); // Set error message
      alert('Failed to submit form. Please try again.');
    } finally {
     // setIsSubmitting(false); // Re-enable the button
    }
  };

  return (
    <>
    <Header />
    <div className="apply-now-container">
      <h2>Get University Shortlisting</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Interested Countries:</label>
          <div className="checkbox-group">
            {countries.map((country) => (
              <div key={country}>
                <input
                  type="checkbox"
                  id={`country-${country}`}
                  name="countriesOfInterest"
                  value={country}
                  onChange={handleChange}
                  
                />
                <label htmlFor={`country-${country}`}>{country}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="studyYear">Which year you are planning to study abroad?</label>
          <select id="studyYear" name="studyYear" value={formData.studyYear} onChange={handleChange} required>
            <option value="">Select Year</option>
            {studyYears.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="highestQualification">Highest Qualification:</label>
          <select
            id="highestQualification"
            name="highestQualification"
            value={formData.highestQualification}
            onChange={handleChange}
            required
          >
            <option value="">Select Qualification</option>
            {qualifications.map((qualification) => (
              <option key={qualification} value={qualification}>{qualification}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="graduationYear">Year of Passing:</label>
          <input
            type="number"
            id="graduationYear"
            name="graduationYear"
            value={formData.graduationYear}
            onChange={handleChange}
            min="1990" // Adjust as needed
            max={new Date().getFullYear() + 5} // Adjust as needed
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="studyBranch">Branch of Study:</label>
          <input
            type="text"
            id="studyBranch"
            name="studyBranch"
            value={formData.studyBranch}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="fullName">Full Name:</label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="mobileNumber">Mobile Number:</label>
          <input
            type="number"
            id="mobileNumber"
            name="mobileNumber"
            value={formData.mobileNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="emailAddress">Email Address:</label>
          <input
            type="email"
            id="emailAddress"
            name="emailAddress"
            value={formData.emailAddress}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="cityOfBirth">Currently City:</label>
          <input
            type="text"
            id="cityOfBirth"
            name="cityOfBirth"
            value={formData.cityOfBirth}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="referralSource">How did you hear about Dream Destination Abroad?</label>
          <select
            id="referralSource"
            name="referralSource"
            value={formData.referralSource}
            onChange={handleChange}
            required
          >
            <option value="">Select Option</option>
            {referralSources.map((source) => (
              <option key={source} value={source}>{source}</option>
            ))}
            {/* <option value="other">Other</option> */}
          </select>
          
        </div>

        <button type="submit">Get University Shortlisting</button>
      </form>
    </div>
    <TaskBar />
    <CopyRight />
    </>
  );
};

export default ApplyNow;